import { useEffect, useRef } from 'react'

export const DELIVERY_POLL_INTERVAL_MS = 60000

export const usePendingDeliveryPoll = ({ enabled, onPoll, intervalMs = DELIVERY_POLL_INTERVAL_MS }) => {
  const onPollRef = useRef(onPoll)

  useEffect(() => {
    onPollRef.current = onPoll
  }, [onPoll])

  useEffect(() => {
    if (!enabled) return undefined

    let timer = null

    const stop = () => {
      if (timer !== null) {
        clearInterval(timer)
        timer = null
      }
    }

    const start = () => {
      if (timer === null) {
        timer = setInterval(() => onPollRef.current(), intervalMs)
      }
    }

    const syncWithVisibility = () => {
      if (document.visibilityState === 'visible') start()
      else stop()
    }

    syncWithVisibility()
    document.addEventListener('visibilitychange', syncWithVisibility)

    return () => {
      stop()
      document.removeEventListener('visibilitychange', syncWithVisibility)
    }
  }, [enabled, intervalMs])
}
